(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csm-text-image-below"] && !Shopify.designMode) return;
  try {
    
  <!-- None needed for basic interactivity -->

  } catch(e) { console.error(e); }
})();
})();
